import * as React from 'react';
import type { HelpTopic } from '@chess/api-help';

// The help topic behind the card's "?": which games count as ahead, and how
// a lead not converted gets its cause. Registered by this plugin's setup.
export const CONVERSION_HELP = 'middlegame.conversion';

export const conversionHelp: HelpTopic = {
  title: 'Converting an advantage',
  body: (
    <>
      <p>
        This card looks at your games of the last 30 days where you stood <b>winning</b> at some point in the middlegame: before one of your middlegame moves, the
        engine had you up by at least your <b>Winning</b> setting (2 pawns by default), the same line Middlegame results uses for a winning position.
      </p>
      <p>
        Middlegame results only compares where the middlegame started and where it ended, so a lead you built and lost inside the middlegame shows there as
        Level or Behind. Here it counts.
      </p>
      <h3>The bar</h3>
      <p>Those games by how they ended: won, drawn or lost, the three numbers beside it in the same colours. Each part and each number opens those games in the library.</p>
      <h3>Where the lead went</h3>
      <p>
        For each game you didn't win, the cause that cost you the most win chance from the moment you stood winning to the end of the game, by the same rule as
        Moves to practise: <b>Tactics</b>, <b>Missed chances</b>, <b>Time trouble</b> (moves made with under a minute left), <b>Positional</b>. A game lost on
        time is Time trouble. The rows under the bar are these causes: the three largest, most games first; a cause with no game is left out.
      </p>
      <p>
        A game where no blunder or miss explains it (a slow slide of small inaccuracies) has <b>no single mistake</b> to blame and gets no row; the library
        lists those games with the Middlegame lead filter set to "Lead lost, no single mistake".
      </p>
      <p>Each row opens those games; each game's review has the move to practise.</p>
    </>
  ),
};
